import { defineMessages } from 'react-intl';

export const studyTypeMessages = defineMessages({
  cbct: {
    id: 'studyType.cbct',
    defaultMessage: 'CBCT',
  },
  ioxRay: {
    id: 'studyType.ioxRay',
    defaultMessage: 'IOXRay',
  },
  pano: {
    id: 'studyType.pano',
    defaultMessage: 'Pano',
  },
  intraoralScan: {
    id: 'studyType.intraoralScan',
    defaultMessage: 'Intraoral Scan',
  },
  dentalPhotos: {
    id: 'studyType.dentalPhotos',
    defaultMessage: 'Dental Photos',
  },
  transcriptor: {
    id: 'studyType.transcriptor',
    defaultMessage: 'Transcriptor',
  },
});
